<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false"
    @close="dialogClose">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ $t('set_trade_password.title') }}</p>
    <p class="p2 mt20">{{ $t("password_recovery.tip3") }}</p>
    <el-form
      class="mt20"
      :model="formData"
      :rules="rules"
      ref="ruleFormSetTransPWD"
    >
      <el-form-item :label="$t('user_assets.trans_password_placeholder')" prop="password">
        <el-input v-model="formData.password"  :placeholder="$t('tipsVal.inputPlaceholder')" type="password"/>
      </el-form-item>
      <el-form-item :label="$t('password_recovery.confirm')" prop="passwordConfirm">
        <el-input v-model="formData.passwordConfirm"  :placeholder="$t('tipsVal.inputPlaceholder')"  type="password"/>
      </el-form-item>
      <el-form-item
        :label="$t('google_bind.phone_code')"
        prop="phoneCode"
        v-if="user.phoneSecurity === 1"
      >
        <el-input v-model="formData.phoneCode"  :placeholder="$t('tipsVal.inputPlaceholder')">
          <template slot="append"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("set_trade_password.getCode") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('google_bind.email_code')"
        prop="emailCode"
        v-if="user.emailSecurity === 1"
      >
        <el-input v-model="formData.emailCode"  :placeholder="$t('tipsVal.inputPlaceholder')">
          <template slot="append"
            ><span v-if="!emailCodeStatus.hasSend" @click="hasSendEmailCode">
              {{ $t("password_recovery.getCode") }}</span
            >
            <span v-else>{{ emailCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('modify_trade_password.google_code')"
        prop="googleCode"
        v-if="user.googleSecurity === 1"
      >
        <el-input
          v-model="formData.googleCode"
          maxlength="10"
          :placeholder="$t('modify_trade_password.google_placeholder')"
        />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">{{ $t('buy_box.confirm') }}</div>
    </div>
  </el-dialog>
</template>

<script>
import bus from "@/assets/js/bus";
import { mapState } from "vuex";
export default {
  data() {
    let passwordConfirmValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("validate.password_confirm_again")));
      } else if (value !== this.formData.password) {
        callback(new Error(this.$t("validate.password_confirm_error")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      formData: {
        emailCode: "",
        emailToken: "",
        password: "",
        passwordConfirm: "",
        phoneCode: "",
        phoneToken: "",
        googleCode: "",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.mes_code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.email_code_require"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
          {
            pattern: bus.regs.transPWD,
            message: this.$t("validate.trans_password_formatter_tip"),
            trigger: "blur",
          },
        ],
        passwordConfirm: [
          { validator: passwordConfirmValidate, trigger: "blur" },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("validate.google_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  methods: {
    hasSendPhoneCode() {
      if (this.user.phoneVerify === -1) {
        this.$message({
          type: "error",
          message: this.$t("set_trade_password.bind_phone"),
        });
        return false;
      }
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendTransactionPwdCode", {
          serviceName: "setTrxPwd",
          verifyType: "phone",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      if (this.user.emailVerify === -1) {
        this.$message({
          type: "error",
          message: this.$t("set_trade_password.bind_email"),
        });
        return false;
      }
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendTransactionPwdCode", {
          serviceName: "setTrxPwd",
          verifyType: "email",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    submit() {
      let ref = this.$refs.ruleFormSetTransPWD;
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$axios
            .post("/user/setTransactionPwd", this.formData)
            .then((res) => {
              if (res.data.code === this.errorCode.ok) {
                this.elMessage(
                  "success",
                  this.$t("set_trade_password.success"),
                );
                this.$store.dispatch("actions_getUserInfo").then((res) => {
                  this.dialogVisible = false;
                });
              } else {
                this.elMessage("error", res.data.msg);
              }
            });
        }
      });
    },
    dialogClose() {
      this.$refs.ruleFormSetTransPWD.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: var(--primary-color);
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #f04545;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: var(--primary-color);
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
